import { Component, inject } from '@angular/core';
import { HelmetService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  HelmetCreateDto,
  HelmetDto,
  HelmetExcelDownloadDto,
  HelmetUpdateDto,
} from '../proxy/planning/dtos/helmet';
import { HELMET_CONFIG, HELMET_FIELDS } from './helmet.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-helmet',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, HelmetService, ConfirmationService],
  templateUrl: './helmet.html',
  styleUrl: './helmet.scss',
})
export class Helmet extends BaseHierarchicalCrudComponent<
  HelmetDto,
  HelmetCreateDto,
  HelmetUpdateDto,
  HelmetExcelDownloadDto
> {
  service = inject(HelmetService);
  config = HELMET_CONFIG;
  fields = HELMET_FIELDS;

  protected prepareUpdateDto(data: any, selected: HelmetDto): HelmetUpdateDto {
    return {
      name: data.name,
      locationId: data.locationId,
      propertyId: data.propertyId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Helmet';
  }
}
